export const OUTLAW_COOKIES = {
  user_token: 'user-token',
  guest_data: 'guest-data',
  user_data: 'user-data',
  notification_token: 'notification',
  path_before_registration: 'pathBeforeRegistration',
  authorization_flow: 'authorization_flow',
  hide_full_layout_banner: 'hide_full_layout_banner',
  promocode: 'promocode',
  promocode_error: 'promocode_error',
  promocode_type: 'promocode_type',
  search: 'search',
  theme: 'theme',
  rent_video_id: 'rent_video_id',
  return_episode_id: 'return_episode_id',
  return_film_id: 'return_film_id',
  return_post_id: 'return_post_id',
  return_playlist_id: 'return_playlist_id',
  return_show_id: 'return_show_id',
  return_star_id: 'return_star_id',
  share_user_id: 'share_user_id',
  return_url: 'return_url',
  offer_id: 'offer_id',
  subscribe: 'subscribe',
  showed_competition_popup: 'showed_competition_popup',
  competition_to_buy: 'competition_to_buy',
  hide_points_banner: 'hide_points_banner',
  purchased_channel_title: 'purchased_channel_title',
  skip_interests: 'skip_interests',
  showed_multi_likes_popup: 'showed_multi_likes_popup',
  showed_multi_likes_done_popup: 'showed_multi_likes_done_popup',
  was_sent_to_app: 'was_sent_to_app',
  return_subscribe_page: 'return_subscribe_page',
};
